import React, { useEffect, useState } from "react";
import tower from "../assets/images/tower.png";
import africaImage from "../assets/images/africa.svg";
import asiaImage from "../assets/images/asia.svg";
import caribbean from "../assets/images/caribbean.svg";
import europe from "../assets/images/europe.svg";
import MiddleEast from "../assets/images/MiddleEast.svg";
import NorthAmerica from "../assets/images/NorthAmerica.svg";
import Southlationamerica from "../assets/images/SouthLationAmerica.svg";
import Global from "../assets/images/Global.svg";

import { LuDatabase } from "react-icons/lu";
import { MdOutlineWatchLater, MdOutlineSpeed } from "react-icons/md";
import { HiOutlineGlobe } from "react-icons/hi";
import { IoPlayCircleOutline } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import QRCode from "qrcode.react";
import { ImCross } from "react-icons/im";
import { GoDownload } from "react-icons/go";
import { saveAs } from "file-saver";
import LoadingSpinner from "../components/LoadingSpinner";
import { toast } from "react-toastify";
import PlanImage from "../assets/images/New_Jul_2025/PlanMap.svg";
import { sessionTimeoutManager } from "../utils/sessionTimeoutManager";
import Logind from "../assets/images/New_Jul_2025/Login.svg";
import Phone from "../assets/images/New_Jul_2025/Phone.svg";
import Message from "../assets/images/New_Jul_2025/Message.svg";
import Play from "../assets/images/New_Jul_2025/Play.svg";
import Shield from "../assets/images/New_Jul_2025/Shield.svg";
import wifi from "../assets/images/New_Jul_2025/wifi.svg";
import tick from "../assets/images/New_Jul_2025/tick.svg";
import Information from "../assets/images/New_Jul_2025/Information.svg";
import Location from "../assets/images/New_Jul_2025/Location.svg";
import hotspot from "../assets/images/New_Jul_2025/hotspot.svg";
import setting from "../assets/images/New_Jul_2025/setting.svg";

const Plan = () => {
  const [planDetails, setPlanDetails] = useState(null);
  const [showQRModal, setShowQRModal] = useState(false);
  const [lpacode, setLpaCode] = useState("");
  const [purchaseDetails, setPurchaseDetails] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");

  const [activeTab, setActiveTab] = useState("Overview");

  const tabs = ["Overview", "Features", "More information"];

  const navigate = useNavigate();
  const apiUrl = process.env.REACT_APP_BASE_URL;
  const [userRole, setUserRole] = useState(null);

  useEffect(() => {
    const role = localStorage.getItem("role");
    setUserRole(role);
  }, []);

  useEffect(() => {
    const token = localStorage.getItem("token");
    const partnerCode = localStorage.getItem("partnerCode");
    const plan_id = localStorage.getItem("plan_id");

    fetch(
      `${apiUrl}Esim/Get_plan_details_byid?plan_id=${plan_id}&Partnercode=${partnerCode}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
      .then((response) => {
        if (response.status === 401 || response.status === 403) {
          // trigger global session timeout modal
          sessionTimeoutManager.showSessionTimeout();
          throw new Error("Session expired or access forbidden");
        }
        return response.json();
      })
      .then((data) => {
        if (data.isSuccess) {
          setPlanDetails(data);
        } else {
          console.error("Failed to fetch plan details:", data.message);
        }
      })
      .catch((error) => {
        console.error("Error fetching plan details:", error);
      });
  }, []);

  const handleAddBundle = () => {
    const partnerCode = localStorage.getItem("partnerCode");
    const planCode = localStorage.getItem("planCode");
    const token = localStorage.getItem("token");

    if (!token) {
      console.error("No token found in localStorage");
      return;
    }

    setLoading(true);

    const requestData = {
      partnerCode: partnerCode,
      planCode: [planCode],
      travelDate: "",
      quantity_plan: 1,
    };

    fetch(`${apiUrl}Esim/PurhaseSim_Bundle`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestData),
    })
      .then((response) => {
        if (response.status === 401 || response.status === 403) {
          sessionTimeoutManager.showSessionTimeout();
          throw new Error("Session expired or access forbidden");
        }
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        console.log("API response:", data);
        if (!data.isSuccess) {
          throw new Error(data.message);
        }

        const purchasePlan =
          data.purchaseplanlist && data.purchaseplanlist.length > 0
            ? data.purchaseplanlist[0]
            : null;

        if (purchasePlan) {
          setPurchaseDetails(purchasePlan);
        }

        setLpaCode(data.lpacode);
        setShowQRModal(true);

        setModalMessage("Plan purchased successfully!");
        setShowSuccessModal(true);

        setTimeout(() => {
          setShowSuccessModal(false);
        }, 1000);

        setTimeout(() => {
          setShowConfirmModal(false);
        }, 1000);
      })
      .catch((error) => {
        console.error("There was a problem with the API request:", error);
        toast.error("Error: " + error.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleDownload = (lpacode) => {
    const qrCodeUrl = `https://api.qrserver.com/v1/create-qr-code/?data=${lpacode}&size=200x200`;
    saveAs(qrCodeUrl, `QR_${lpacode}.png`);
  };

  if (!planDetails) {
    return (
      <div>
        <LoadingSpinner />
      </div>
    );
  }

  const handleCross = () => {
    setShowQRModal(false);
  };

  const { sellingcost, sellingcost_airhub, discount, planlist,isStock } = planDetails;
  const {
    validity,
    dataallowance,
    plantype,
    apN_PIN,
    operatorname,
    planCode,
    type,
    planClass,remarks,countryName,
    supportedCountryCount,plan_Type,recharge,supplier,conditions
  } = planlist[0];
  const addInfo = planlist[0].addinformation || "";

  // Safely extract packageHTML from addInfo
  const extractPackageHTML = (html) => {
    if (!html) return "";

    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");
    const ul = doc.querySelector("ul");

    if (!ul) return html;

    return ul.outerHTML;
  };

  const packageHTML = extractPackageHTML(addInfo);
  console.log("Package HTML:", packageHTML);
  const parseListItems = (ulHtml) => {
    if (!ulHtml) return [<li key="0">No package details available</li>];

    try {
      const cleanedHtml = ulHtml
        .replace(/.*?<ul[^>]*>/s, "")
        .replace(/<\/ul>.*/s, "");

      const items = cleanedHtml
        .split(/<\/li>/)
        .map((item) => item.trim())
        .filter((item) => item.length > 0);

      return items.map((item, index) => (
        <li
          key={index}
          className="m-2"
          dangerouslySetInnerHTML={{ __html: item }}
        />
      ));
    } catch (error) {
      console.error("Error parsing list items:", error);
      return [<li key="0">Error loading package details</li>];
    }
  };

  const selectedRegionId = localStorage.getItem("region");
  let sidebarImage = tower;

  if (selectedRegionId === "12") {
    sidebarImage = africaImage;
  } else if (selectedRegionId === "170") {
    sidebarImage = asiaImage;
  } else if (selectedRegionId === "101") {
    sidebarImage = caribbean;
  } else if (selectedRegionId === "12") {
    sidebarImage = europe;
  } else if (selectedRegionId === "5") {
    sidebarImage = Global;
  } else if (selectedRegionId === "5") {
    sidebarImage = MiddleEast;
  } else if (selectedRegionId === "8") {
    sidebarImage = NorthAmerica;
  } else if (selectedRegionId === "1") {
    sidebarImage = Southlationamerica;
  }

 const hasInternationalCalls =
  remarks &&
  remarks !== "undefined" &&
  /int'?l|international/i.test(remarks);

const features = [
  {
    icon: Logind,
    title: "Country/Region",
    description:
      supportedCountryCount === "0" ? "1" : supportedCountryCount || "1",
  },
  {
    icon: Message,
    title: "Calls & Text",
    description: remarks && remarks !== "undefined" ? remarks : "NA",
  },

  // ✅ Conditional feature
  ...(supplier === "60"
    ? [
        {
          icon: Shield,
           title: "Top-up",
          description: "Top-up available",
        },
      ]
       : supplier === "91"
    ? [
        {
          icon: Logind,
          title: "Top-up",
          description: "Top-up available",
        },
      ]
       : supplier === "126"
    ? [
        {
          icon: Logind,
          title: "Top-up",
          description: "Top-up available",
        },
      ]
    : recharge === "1"
    ? [
        {
          icon: Logind,
          title: "Renewal",
          description: " available",
        },
      ]
    : []),

  {
    icon: Play,
    title: "Autostart Enabled",
    description: "Automatic activation",
  },
  {
    icon: Logind,
    title: "International Calls",
    description: hasInternationalCalls ? "Yes" : "NA",
  },
  {
    icon: Logind,
    title: "Hotspot",
    description: "Share your connection",
  },
  {
    icon: Logind,
    title: "Compatibility",
    description: "eSIM enabled devices",
  },
  {
    icon: Logind,
    title: "Valid From",
    description: conditions && conditions !== "undefined" ? conditions : "NA",
  },
];


  function SuccessModal({ message, onClose }) {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
        <div className="bg-white rounded-lg p-6 shadow-lg max-w-sm w-full relative">
          <button
            onClick={onClose}
            className="absolute top-4 right-4 px-4 py-2 text-white rounded-lg hover:bg-[#20bfb2]"
          >
            <ImCross size={20} color="grey" />
          </button>
          <div className="flex flex-col items-center justify-center h-full">
            <p className="text-5xl font-bold">{message}</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="main-content flex overflow-hidden ">
      <div className="content flex-1 rounded-r-lg overflow-auto">
        <div className="bg-[#3E436D] flex flex-col items-center justify-center p-4 sm:p-6">
          {/* Top header */}
          <div className="flex flex-col items-center  rounded-2xl">
            <img src={Logind} alt="Login" className="w-8 h-8 mb-3 " />
            <h1 className="text-white font-bold text-center text-[1.rem] sm:text-xl">
              {countryName} eSIM Plan
            </h1>
            <span className="text-white font-medium text-center text-xs sm:text-sm">
              Stay connected worldwide
            </span>
          </div>

          {/* Stats cards */}
          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 w-full max-w-md sm:max-w-none">
            <div className="flex flex-col items-center p-1  glass text-white rounded-lg shadow-md flex-1 min-w-[60px]">
              <span className="text-[0.9rem] sm:text-2xl text-center font-bold break-words">
                {dataallowance}
              </span>
              <span>Data</span>
            </div>
            <div className="flex flex-col items-center p-1  glass text-white rounded-lg shadow-md flex-1 min-w-[60px]">
              <span className="text-[0.9rem] sm:text-2xl text-center font-bold break-words">
                {validity}
              </span>
              <span>Validity</span>
            </div>
            <div className="flex flex-col items-center p-1  glass text-white rounded-lg shadow-md flex-1 min-w-[60px]">
              <span className="text-[0.9rem] sm:text-2xl font-bold">  {supportedCountryCount === "0" ? "1" : supportedCountryCount || "1"}</span>
              <span className="text-xs sm:text-sm">Countries</span>
            </div>
          </div>
        </div>

        {/* Tabs: icon + label per tab */}
        <div className="flex mt-2 w-full mx-auto max-w-3xl gap-1">
          {[
            { key: "Overview", icon: wifi, label: "Overview" },
            { key: "Features", icon: tick, label: "Features" },
            {
              key: "More information",
              icon: Information,
              label: "More information",
            },
          ].map(({ key, icon, label }) => (
            <button
              key={key}
              type="button"
              onClick={() => setActiveTab(key)}
              className={`flex items-center gap-2 flex-1 justify-center rounded-[14px] px-4 py-2 text-[0.8rem] font-semibold shadow-md
        ${
          activeTab === key
            ? "bg-white text-[#3E436D] underline underline-offset-[3px] border-2"
            : "bg-white text-slate-800"
        }`}
            >
              <img src={icon} alt={label} className="w-6 h-6 font-bold" />
              <span>{label}</span>
            </button>
          ))}
        </div>

        {activeTab === "Overview" && (
          <>
  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 p-2 ">
    <div className="flex items-center  rounded-xl flex-col md:flex-row shadow-md bg-[#E2E8F0] border-4 w-full m-2">
      <img
        src={Location}
        alt="location"
        className="h-7 w-7 text-white rounded-lg bg-[#3E436D] mr-3"
      />
      <div className="text-center md:text-left">
        <h1 className="text-xs font-semibold md:text-sm">Plan Coverage</h1>
        <span className="text-xs font-normal md:text-sm">{type}</span>
      </div>
    </div>

    <div className="flex items-center  rounded-xl flex-col md:flex-row shadow-md bg-[#E2E8F0] border-4 w-full m-2">
      <img
        src={hotspot}
        alt="hotspot"
        className="h-7 w-7 text-white rounded-lg bg-[#3E436D] mr-3"
      />
      <div className="text-center md:text-left">
        <h1 className="text-xs font-semibold md:text-sm">Plan Type</h1>
        <span className="text-xs font-normal md:text-sm">{planClass}</span>
      </div>
    </div>
  </div>


<div className=" grid grid-cols-1 sm:grid-cols-2 gap-4 items-center justify-between p-4">

            <div className="bg-[#E2E8F0] p-4 rounded-xl">
              <div className="flex items-center gap-2 mb-3">
                <div className="h-8 w-8 rounded-xl bg-[#3E436D] flex items-center justify-center">
                  <img src={setting} alt="setting" className="text-white" />
                </div>
                <h2 className="text-[1.0rem] font-semibold text-slate-700">
                  Network Configuration
                </h2>
              </div>
                            <div className="space-y-2">

              <div className="p-2   rounded-3xl text-xs md:text-sm flex justify-between border-b border-gray-300  cursor-pointer re">
                <span className="font-normal">Operator:</span>
                <span className="ml-4 text-right">{operatorname}</span>
              </div>
              <div className="p-2   rounded-3xl text-xs md:text-sm flex justify-between border-b border-gray-300  cursor-pointer re">
                <span className="font-normal">APN:</span>
                <span className="ml-4 text-right">{apN_PIN}</span>
              </div>
              <div className="p-2   rounded-3xl text-xs md:text-sm flex justify-between border-b border-gray-300  cursor-pointer re">
                <span className="font-normal">Network Type:</span>
                <span className="ml-4 text-right">4G/5G</span>
              </div>
            </div>
                        </div>

            <div className="bg-[#E2E8F0] p-4 rounded-xl">
              <div className="flex items-center gap-2 mb-3">
                <div className="h-8 w-8 rounded-xl bg-[#3E436D] flex items-center justify-center">
                  <img src={tick} alt="Plan" className="text-white" />
                </div>
                <h2 className="text-[1.0rem] font-semibold text-slate-700">
                  Plan Information
                </h2>
              </div>
              <div className="space-y-2">
              <div className="p-2   rounded-3xl text-xs md:text-sm flex justify-between border-b border-gray-300  cursor-pointer re">
                  <span className="font-normal">Plan Code:</span>
                  <span className="ml-4 text-right">{planCode}</span>
                </div>
              <div className="p-2   rounded-3xl text-xs md:text-sm flex justify-between border-b border-gray-300  cursor-pointer re">
                  <span className="font-normal">Activation Method:</span>
                  <span className="ml-4 text-right">QR Code</span>
                </div>
              <div className="p-2   rounded-3xl text-xs md:text-sm flex justify-between border-b border-gray-300  cursor-pointer re">
                  <span className="font-normal">Device Support:</span>
                  <span className="ml-4 text-right">iOS &amp; Android</span>
                </div>
              </div>
            </div>
                          </div>

          </>
        )}

        {/* FEATURES */}
        {activeTab === "Features" && (
          <div className="bg-transparent mb-3">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 p-2">
              {features.map((item, index) => (
                <div
                  key={index}
                  className="flex items-center rounded-xl border bg-white p-3 md:p-4 shadow-sm"
                >
                  <div className="flex h-9 w-9 md:h-10 md:w-10 items-center justify-center rounded-lg bg-[#3E436D] text-white mr-3">
                    <img
                      src={item.icon}
                      alt={item.title}
                      className="h-5 w-5 md:h-6 md:w-6 object-contain"
                    />
                  </div>
                  <div>
                    <p className="text-xs md:text-sm font-medium text-slate-800">
                      {item.title}
                    </p>
                    <p className="text-[11px] md:text-xs font-semibold text-black">
                      {item.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* MORE INFORMATION */}
        {activeTab === "More information" && (
           <>
          {/* <div className="bg-white rounded-2xl p-4 md:p-6 mb-1">
            <div className="flex">
             <img src={hotspot}alt="hotspot"className="h-7 w-7 text-white rounded-lg bg-[#3E436D] mr-3 "/>
            <h1 className="text-[#3E436D] font-bold text-xs md:text-sm mb-1">
              HOTSPOT CAPABILITY
            </h1>
            </div>
            <p className="text-xs md:text-sm text-slate-700">
              Turn your phone into a hotspot for others to connect to.
            </p>
          </div> */}
                    <div className="bg-white rounded-2xl  md:p-6">

           <div className="flex ">
             <img src={Phone}alt="hotspot"className="h-7 w-7 text-white rounded-lg bg-[#3E436D] mr-3 p-2"/>
            <h1 className="text-[#3E436D] font-bold text-xs md:text-sm mb-1">
              Package Details
            </h1>
            </div>
       
        <div className="flex flex-col lg:flex-row gap-8">
          <div className="flex-1">
            <ul className="list-disc ml-5">
              {parseListItems(packageHTML)}
            </ul>
          
          </div>
     
        </div>

       
       </div>
       </>
        )}

        {/* CTA button */}
     
        {/* CTA button */}
        <div className="flex justify-end items-center p-3 sm:p-4 max-w-3xl mx-auto">
          <button
            className="w-full sm:min-w-[200px] rounded-2xl bg-[#3E436D] hover:bg-[#9fa3d0] text-white font-bold px-6 py-3 text-sm sm:text-base transition duration-200"
            onClick={() => setShowConfirmModal(true)}
            disabled={loading}
          >
            {userRole === "Partner"
              ? loading
                ? "Processing Purchase..."
                : `Buy Now - $${parseFloat(sellingcost).toFixed(2)}`
              : loading
              ? "Processing..."
              : "Buy"}
          </button>
        </div>
   {/* <div className="flex justify-end items-center p-3 sm:p-4 max-w-3xl mx-auto">
  <button
    className={`w-full sm:min-w-[200px] rounded-2xl font-bold px-6 py-3 text-sm sm:text-base transition duration-200
      ${
        Number(isStock) === 0
          ? "bg-gray-400 cursor-not-allowed"
          : "bg-[#3E436D] hover:bg-[#9fa3d0] text-white"
      }
    `}
    onClick={() => setShowConfirmModal(true)}
    disabled={loading || Number(isStock) === 0}
  >
    {Number(isStock) === 0
      ? "Plan is out of stock"
      : userRole === "Partner"
        ? loading
          ? "Processing Purchase..."
          : `Buy Now - $${parseFloat(sellingcost).toFixed(2)}`
        : loading
          ? "Processing..."
          : `Buy Now - $${parseFloat(isStock).toFixed(2)}`}
  </button>
</div> */}

        {/* <div className="flex flex-col lg:flex-row gap-8">
          <div className="flex-1">
            <h2 className="text-xl font-bold mb-4">Package Details</h2>
            <ul className="list-disc ml-5">
              {parseListItems(packageHTML)}
            </ul>
            <p className="mt-4">
              <b>Compatibility:</b> Supports Android and iOS devices<br />
              (refer to FAQ for compatible handsets).
            </p>
          </div>
      <div className="flex-1 flex justify-center hidden md:block">
            <img
              src={PlanImage}
              alt="Region Illustration"
              className="max-w-full max-h-full rounded-lg shadow-md"
            />
          </div>
        </div> */}

        {showSuccessModal && (
          <SuccessModal
            message={modalMessage}
            onClose={() => setShowSuccessModal(false)}
          />
        )}

        {showQRModal && purchaseDetails && (
          <div className="fixed top-0 left-0 w-full h-full bg-gray-900 bg-opacity-50 flex items-center justify-center">
            <div className="bg-white p-8 rounded-md flex flex-row relative">
              {/* Left column */}
              <div className="flex flex-col items-start w-96">
                <div className="mb-4 p-4 w-full border-4 bg-slate-200 rounded-2xl">
                  <span className="font-bold">Order ID:</span>{" "}
                  <span className="ml-4">
                    {purchaseDetails.orderid || "N/A"}
                  </span>
                </div>
                <div className="mb-4 p-4 w-full border-4 bg-slate-200 rounded-2xl">
                  <span span className="font-bold">
                    APN:
                  </span>{" "}
                  <span className="ml-4">{purchaseDetails.apn || "N/A"}</span>
                </div>
                <div className="mb-4 p-4 w-full border-4 bg-slate-200 rounded-2xl">
                  <span className="font-bold"> ICCID/MSISDN:</span>{" "}
                  <span className="ml-4">{purchaseDetails.iccid || "N/A"}</span>
                </div>
                <div className="mb-4 p-4 w-full border-4 bg-slate-200 rounded-2xl">
                  <span className="font-bold">SIMPIN:</span>{" "}
                  <span className="ml-4">
                    {purchaseDetails.simpin || "N/A"}
                  </span>
                </div>

                {/*              
             <div className="mb-4 p-4 w-full border-4 bg-slate-200 rounded-2xl">
               <span className="font-bold">Authentication code:</span>{' '}
               <span className="ml-4">{purchaseDetails.lpacode || 'N/A'}</span>
             </div> */}
                {/* Here i added a new code like  */}
                <div className="mb-4 p-4 w-full border-4 bg-slate-200 rounded-2xl">
                  <h1 className="font-bold">
                    For iOS Devices:
                    <span className="font-normal">
                      {" "}
                      Use Below SMDP & Activation code
                    </span>
                  </h1>

                  {(() => {
                    const fullCode = purchaseDetails?.lpacode || "";
                    const parts = fullCode.split("$");
                    const smdp = parts.length >= 2 ? parts[1] : "N/A";
                    const activation = parts.length >= 3 ? parts[2] : "N/A";

                    return (
                      <>
                        <div>
                          <span className="font-bold">SMDP:</span>
                          <span className="ml-4">{smdp}</span>
                        </div>
                        <div>
                          <span className="font-bold">Activation Code:</span>
                          <span className="ml-4">{activation}</span>
                        </div>
                      </>
                    );
                  })()}
                </div>
                <div className="mb-4 p-4 w-full border-4 bg-slate-200 rounded-2xl">
                  <h1 className="font-bold">
                    For Andriod Devices:{" "}
                    <span className="font-normal">
                      Enter below Activation Code.
                    </span>{" "}
                  </h1>{" "}
                  {purchaseDetails?.lpacode || "N/A"}
                </div>

                <div className="mb-4 p-4 w-full border-4 bg-[#c5f1f1] rounded-2xl">
                  <span className="font-bold">How to Install ?</span>
                  <a
                    href="https://www.airhubapp.com/info/esim-installation"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="ml-4 border-2 rounded-2xl hover:bg-blue-400 p-2 border-black "
                  >
                    Step by Step Guide
                  </a>
                </div>
              </div>

              {/* Right column */}
              <div className="flex flex-col items-center justify-center ml-8">
                {/* <QRCode value={lpacode} className='border-4 p-2 border-[#47a192]' size={200} /> */}
                <QRCode
                  value={purchaseDetails?.lpacode || "N/A"}
                  className="border-4 p-2 border-[#47a192]"
                  size={200}
                />

                <button
                  className="text-[#595959] flex items-center border border-black px-4 py-2 rounded mt-4"
                  onClick={() => handleDownload(lpacode)}
                  style={{ textDecoration: "none" }}
                >
                  <GoDownload size={30} /> Download
                </button>
              </div>

              {/* Close button */}
              <ImCross
                size={30}
                onClick={handleCross}
                className="cursor-pointer absolute top-2 right-2"
              />
            </div>
          </div>
        )}

        {/* RRA Price and Discount inputs with Buy Now button */}
        <div className="flex mt-12 items-center space-x-2">
          {/* {userRole === "Partner" &&(

<div className="flex flex-wrap -mx-3 mb-6">
                        <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                             <label className="text-teal-900 block font-bold mb-1"> Website  Price </label>
             <p className=" py-6 px-6 rounded-lg w-36 text-center font-bold    text-[2rem]  " >
             {`$${parseFloat(sellingcost_airhub).toFixed(2)}`}
             </p>
        </div> 
        <div className="w-full md:w-1/2 px-3">
        <label className="text-teal-900 block mb-1 text-center   font-bold">Discount 
        </label> <p         className=" py-6 px-6 rounded-lg w-36 text-center font-bold    text-[2rem]  " > {`${discount}% `} </p>
        </div>
        </div>
      )} */}
        </div>

        {showConfirmModal && (
          <div className="fixed top-0 left-0 w-full h-full bg-gray-900 bg-opacity-50 flex items-center justify-center">
            <div className="bg-white p-8 rounded-md flex flex-col items-center relative w-96">
              <h3 className="text-xl font-bold mb-4">
                Are you sure you want to purchase this plan?
              </h3>
              <div className="flex justify-around w-full">
                <button
                  className="px-6 py-2 rounded-lg bg-yellow-500 text-white"
                  onClick={() => {
                    // When Confirm is clicked, start loading and trigger timeout for modal close
                    handleAddBundle();
                  }}
                >
                  Confirm
                </button>
                <button
                  className="px-6 py-2 rounded-lg bg-gray-500 text-white"
                  onClick={() => setShowConfirmModal(false)} // Close the modal on cancel
                >
                  Cancel
                </button>
              </div>
              <ImCross
                size={20}
                onClick={() => setShowConfirmModal(false)}
                className="absolute top-2 right-2 cursor-pointer"
              />
            </div>
          </div>
        )}

        {/* Show Loading Spinner */}
        {loading && (
          <div className="fixed top-0 left-0 w-full h-full bg-gray-900 bg-opacity-50 flex items-center justify-center">
            <div className="spinner">
              <div className="loader">
                <LoadingSpinner />
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Plan;
